import _ from 'lodash';
import compositesDefinition from './compositeDefinitions';
import compositeFactory from './compositeFactory';

var Composites = _.mapValues(compositesDefinition.AllCompositeDefinitions, function (v) {
  return compositeFactory(v);
});

export default Composites;